import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.ACTIVE_ORDERS_LIST_SUCCESS, data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.ACTIVE_ORDERS_LIST_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const activeOrdersList = (clientId) => {
  return async (dispatch) => {
    dispatch({ type: CONST.ACTIVE_ORDERS_LIST_REQUEST });

    axios
      .get(`/tickets/active-orders/${clientId}`)
      .then((response) => {
        handleResponse(dispatch, response);
      })
      .catch((error) => console.error(error));
  };
};
